import { object, string, number, array } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const displayCategorySchema = object({
  name: string({ required_error: IS_REQUIRED }),
  rank: number().optional(),
  bannerIds: array(string().optional()).optional(),
});

export const validateDisplayCategory = makeValidate(displayCategorySchema);
